if (!customElements.get('discount-copy')) {
  customElements.define('discount-copy',
    class DiscountCopy extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.button = this.querySelector('[data-copy-discount-button]');
        this.codeElement = this.querySelector('[data-copy-discount-code]');

        if (!this.button || !this.codeElement) return;

        this.button.addEventListener('click', () => this.copyCode());
      }

      async copyCode() {
        const code = this.codeElement.textContent.trim();
        if (!code) return;

        await navigator.clipboard.writeText(code);
        this.setButtonState(true);
      }

      setButtonState(copied) {
        if (!this.button) return;

        this.classList.add('copied');

        window.clearTimeout(this.resetTimeout);
        this.resetTimeout = window.setTimeout(() => {
          this.classList.remove('copied');
        }, 4000);
      }
    }
  );
}